import { useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_entertainment-hub-187/artifacts/jgyw0hiu_1000010836.png";

const links = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Showreel", href: "#showreel" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "FAQs", href: "#faqs" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#home" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src={LOGO} alt="Robust Entertainment" className="h-14 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-zinc-400 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://wa.me/447539528505"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-button"
            className="btn-glow-red bg-[#FF2A2A] hover:bg-[#FF4D4D] text-white text-sm font-medium px-6 py-2.5 rounded-full transition-all duration-300"
          >
            Book a Discovery Call
          </a>
        </nav>
        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-zinc-300 hover:text-white text-base py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://wa.me/447539528505"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="bg-[#FF2A2A] text-white text-center font-medium px-6 py-3 rounded-full mt-2"
          >
            Book a Discovery Call
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
